import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import AnswerRenderer from '../AnswerRenderer';
import './AnswerSection.scss';
import { getRequest } from '../../../requestUtils';

class AnswerSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: null,
      showReadMore: false,
      isReadingMore: props.isReadingMore,
    };
    this.getAndSetAnswers = this.getAndSetAnswers.bind(this);
    this.getAnswers = this.getAnswers.bind(this);
    this.updateSingleAnswer = this.updateSingleAnswer.bind(this);
    this.readMore = this.readMore.bind(this);
  }

  componentDidMount() {
    this.getAndSetAnswers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.fullView !== prevProps.fullView) {
      this.getAndSetAnswers();
    }
  }

  getAndSetAnswers() {
    this.getAnswers()
      .then((response) => {
        const answers = response.data;
        this.setState({ answers });

        const isOneSection = answers && answers.length === 1;
        const isTagFilled = answers && answers
          .reduce((filledTags, answer) => (
            answer.answer
                  && (answer.answer.length !== 0)
              ? filledTags + 1 : filledTags), 0);

        this.setState({
          showReadMore:
        isTagFilled > 5
        || (isOneSection
          && ((answers[0].question_type === 'group_parent' && answers[0].question_key !== 'Language')
            || answers[0].question_type === 'list' || answers[0].question_type === 'past_roles')
          && answers[0].answer && answers[0].answer.length > 2),
        });
      });
  }

  getAnswers() {
    const {
      fullView,
      questionCategoryId,
      questionableId,
      questionableType,
      questionnaireName,
    } = this.props;
    return getRequest(
      '/question_answers/answers',
      {
        questionnaire_name: questionnaireName,
        question_category_id: questionCategoryId,
        questionable_id: questionableId,
        questionable_type: questionableType,
        full_view: fullView,
      },
    );
  }

  updateSingleAnswer(answer) {
    const { questionableId, questionableType, updateCompletionPercentage } = this.props;
    const { answers } = this.state;

    getRequest(
      `/question_answers/${answer.id}`,
      { questionable_id: questionableId, questionable_type: questionableType },
    ).then((response) => {
      updateCompletionPercentage();
      const newAnswer = response.data;
      const curAnswerIndex = answers.findIndex((a) => a.id === newAnswer.id);
      if (curAnswerIndex !== -1) {
        const newAnswers = update(answers, { [curAnswerIndex]: { $set: newAnswer } });
        this.setState({ answers: newAnswers });
      }
    });
  }

  readMore() {
    this.setState({ isReadingMore: !this.state.isReadingMore });
  }

  isReadingMoreStatus() {
    const { fullView } = this.props;
    const { answers, isReadingMore, showReadMore } = this.state;

    if (answers[0].question_type === 'past_roles') return isReadingMore;

    return fullView || (showReadMore ? isReadingMore : true);
  }

  render() {
    const {
      customClass,
      title,
      fullView,
      questionableId,
      questionableType,
      csrfToken,
      editMode,
      questionnaireName,
      hideFooterButton,
      suggestedTags,
      updateSuggestedTags,
      showSuggestionModal,
    } = this.props;
    const { answers, showReadMore, isReadingMore } = this.state;

    if (answers && answers.length === 0) {
      return null;
    }

    if (answers && answers.length > 0) {
      const answs = answers.filter((a) => fullView || a.public === true);
      const truncateAnswers = !fullView && showReadMore && !isReadingMore;
      if ((title === 'Technical Experience') && !fullView
        && (answers.reduce((filledTags, answer) => ((answer.answer.length !== 0)
          ? filledTags + 1 : filledTags), 0)) < 1) { return null; }

      if (!(title === 'Technical Experience') && ((answers[0].answer === null)
        || (answers[0].answer.length === 0) || (answers[0].answer === 'Not Applicable'))
        && !fullView) { return null; }

      return (
        <div className={`answer-section ${customClass} ${title}`}>
          {answers.length > 1
            && <h2 className={`section-title ${title && 'mb-4'}`}>{title}</h2>}
          <div className="profile-flex flex-children-50">
            {answs.map((answer) => {
              if (fullView || answer.answer !== 'Not Applicable') {
                return (
                  <AnswerRenderer
                    questionableId={questionableId}
                    questionableType={questionableType}
                    fullView={fullView}
                    key={answer.id}
                    answer={answer}
                    childrenQuestionIds={
                      answer.children_questions ? answer.children_questions.map((q) => q.qq_id) : []
                    }
                    editMode={editMode}
                    questionnaireName={fullView ? questionnaireName : ''}
                    suggestedTags={suggestedTags[answer.association_model]}
                    updateSuggestedTags={updateSuggestedTags}
                    csrfToken={csrfToken}
                    showSuggestionModal={showSuggestionModal}
                    editable={fullView}
                    isReadingMore={this.isReadingMoreStatus()}
                    readingMoreThreshhold={answers[0].question_type === 'past_roles' ? 5 : 2}
                    closeModalCallback={this.updateSingleAnswer}
                    hideFooterButton={hideFooterButton}
                    paginated={answer.paginated_modal}
                    truncateAnswers={truncateAnswers}
                  />
                );
              }
              return null;
            })}
            {(answers[0].question_type === 'past_roles' || (!fullView && showReadMore))
              && (
              <div className="align mt-3">
                <a
                  className="body-text-2"
                  tabIndex={0}
                  role="link"
                  onClick={this.readMore}
                >
                  {isReadingMore ? 'View less' : 'View all'}
                  {' '}
                  {title ? title.toLowerCase() : answs[0].question_key.toLowerCase()}
                </a>
              </div>
              )}
          </div>
        </div>
      );
    }

    return (
      <div className={`answer-section ${customClass}`}>
        <h2 className="section-title">{title}</h2>
        <div className="profile-flex flex-children-50">
          <div className="body-text-2">Loading...</div>
        </div>
      </div>
    );
  }
}

AnswerSection.propTypes = {
  questionCategoryId: PropTypes.number.isRequired,
  title: PropTypes.string,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  hideFooterButton: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  isReadingMore: PropTypes.bool,
};

AnswerSection.defaultProps = {
  title: '',
  customClass: '',
  fullView: true,
  editMode: false,
  hideFooterButton: false,
  updateCompletionPercentage: () => {},
  suggestedTags: {},
  updateSuggestedTags: () => {},
  showSuggestionModal: '',
  isReadingMore: false,
};

export default AnswerSection;
